<template>
  <div>
    <a class="ir-arriba" href="#" title="Volver arriba">
      <span class="fa-stack">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-arrow-up fa-stack-2x fa-inverse"></i>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: "GoToTop",
  data() {
    return {};
  },
  props: {},
  methods: {}
};
</script>

<style scoped>
.ir-arriba {
  background-repeat: no-repeat;
  font-size: 10px;
  color: blue;
  cursor: pointer;
  position: fixed;
  bottom: 20px;
  right: 40px;
  opacity: 0.4;
}
.ir-arriba:hover {
    opacity: 0.8;
}
</style>